/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".page_banner[_ngcontent-%COMP%]{background:url(/assets/images/integracaoSistema.png) center center no-repeat #333;position:relative}\n/*# sourceMappingURL=integracao-de-sistemas.component.css.map*/"];
export { styles as styles };
